import React, { useEffect, useLayoutEffect, useState } from 'react';
import CredentialOldListDumb from './CredentialOldListDumb';
import queryString from 'query-string';
import { withRouter, useHistory } from 'react-router-dom';
import { useUser, useList, useCredential } from 'components/hooks';
import { formatProjectItems } from 'helpers';
import { Alert, ModalAlert, ErrorScreen } from 'components/common';
import withRequest from 'hoc/withRequest';
import { ROUTES } from 'consts';

const CredentialOldListSmart = (props) => {
  const { parameters, filters, setFilters } = useUser();
  const projects = formatProjectItems(parameters);
  const projectsMap = projects.reduce((a, v) => ({ ...a, [v.value]: v}), {}) ;
  const { getContentList, content, error, isLoaded } = useList('credentials');
  const credential = useCredential();
  const history = useHistory();
  const [openModal, setOpenModal] = useState(false);
  const [credentialSelected, setCredentialSelected] = useState(null);
  let { project=filters.project } = queryString.parse(props.location.search);

  const handleListPage = () => {
    if (project !== filters.project) setFilters({ project });
    if (project && !!projectsMap[project]) {
      getContentList({
        query: {
          projectId: project
        },
      });
    } else history.push(`?project=${projects[0].value}`);
  };

  const handleCleanUp = () => {
    credential.cleanUpMessage();
  }

  const handleSearch = (data) => {
    let routeToPush = `${ROUTES.CREDENTIAL_LIST}?project=${data.project}`;
    history.push(routeToPush);
  };

  const handleCreate = () => {
    handleCleanUp();
    history.push(ROUTES.CREDENTIAL_CREATE);
  };

  const handleEdit = (credential) => {
    handleCleanUp();
    history.push(`${ROUTES.CREDENTIAL_EDIT}/${credential.credentials_id}`);
  };

  const handleDelete = () => {
    const { credentials_id } = credentialSelected;
    const body = { credentials_id }
    credential.deleteCredential({ body });
    setOpenModal(false);
  };

  const handleModalDelete = (credential) => {
    setCredentialSelected(credential);
    setOpenModal(true);
  };

  const alerts = [
    {
      severity: 'success',
      open: credential.success.post,
      message: 'credentialList.components.alert.success',
    },
    {
      severity: 'success',
      open: credential.success.delete,
      message: 'credentialList.components.alert.deleteSuccess',
    },
    {
      severity: 'info',
      open: credential.success.put,
      message: 'credentialList.components.alert.putSuccess',
    },
    {
      severity: 'error',
      open: credential.error.put,
      message: 'credentialList.components.alert.error',
    },
    {
      severity: 'error',
      open: credential.error.delete,
      message: 'credentialList.components.alert.error',
    },
    {
      severity: 'error',
      open: credential.error.post,
      message: 'credentialList.components.alert.error',
    },
  ];

  useEffect(() => {
    handleListPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project]);

  useLayoutEffect(() => {
    if (filters.project) handleSearch({ project: filters.project });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      credential.success.get ||
      credential.success.post ||
      credential.success.put ||
      credential.success.delete
    ) {
      handleListPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    credential.success.get,
    credential.success.post,
    credential.success.put,
    credential.success.delete,
  ]);

  return (
    <>
      { error ? (
        <ErrorScreen />
      ) : (
        <CredentialOldListDumb
          handleSearch={handleSearch}
          handleCreate={handleCreate}
          handleEdit={handleEdit}
          handleDelete={handleModalDelete}
          content={content}
          options={projects}
          isLoaded={isLoaded}
          defaultValues={{
            project: !project ? projects[0].value : project,
          }}
        />
      )}

      { alerts.map((alert, index) => (
        <Alert
          key={index}
          severity={alert.severity}
          handleClose={() => credential.cleanUpMessage()}
          open={alert.open}
          message={alert.message}
        />
      ))}

      <ModalAlert
        open={openModal}
        handleClose={() => setOpenModal(false)}
        handleConfirm={handleDelete}
      />
    </>
  );



}

export default withRequest(withRouter(CredentialOldListSmart));
